module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"captureImage":"Snap Picture","more":"More","flod":"Fold","noData":"No Data"},"zh":{"captureImage":"抓拍图像","more":"更多","flod":"折叠","noData":"暂无数据"}}')
  delete Component.options._Ctor
}
